<template>
<div>
    <generic-module-view
        :generic_module_view="false"
        :current_module="module_info"
        :module_languages="module_languages"
        :available_languages="[]"
        @createModule="createModule"
        @addNewLessonModule="addNewLessonModule"
        >

        <div slot="program-agency">
                <hr>
                <div class="col-8 mt-2 ml-0">
                    <!-- <h6>Module ID</h6> -->
                </div>

                <!-- <hr> -->
                <div class="col-12 mt-2 ml-0">
                    <h6>Notes</h6>
                    <textarea
                        v-model="module_info.notes"
                        v-validate="''"
                        class="form-control mb-2 height-180 "
                        placeholder="Module Notes`"
                        name="notes"
                    ></textarea>
                    <hr>
                </div>
        </div>
    </generic-module-view>
</div>
</template>
<script>
import PictureInput from 'vue-picture-input';
import GenericModuleView from '../SharedViews/GenericModuleView'
import ProgramLessonView from '../SharedViews/ProgramLessonView'
import myMixin from '../MixinSME'
export default{
    components: {
		PictureInput, GenericModuleView,ProgramLessonView
	},
    data : function(){
        return{
            tabIndex:0,
            modalShow: false,
            notes:'Some notes here',
            lesson_edit:false,
            checked:true,
            module_info:{
                title:'',
                id:'',
                name:'',
                description : '',
                has_quiz:false,
                image:'',
                notes:''
            },
            attachmentsDropzoneOptions: {
                url : this.config.UPLOAD_ATTACHMENT_FILES,
                thumbnailWidth: 50,
                maxFilesize: 500,
                maxFiles : 100,
                addRemoveLinks : true,
                timeout : 300000,
                headers : {
                    'Autrollization' : localStorage.getItem('token')
                }
            },
            languages_all :null,
            module_languages:[],
            selected_language:[]

        }
    },
    mixins:[myMixin],
    created: function(){

    },
    methods:{
        attachmentUploaded : function(file, response){
            
        },
        addNewLessonModule:function(value){
            this.selected_language.push(value)

        },
        createModule: function(module_info){
            this.$store.dispatch('createModule', module_info).then((res) => {
                    res.data.module.lessons = [];
					res.data.module.courses = [];
					res.data.module.name = {}
					res.data.module.description = {}
                    this.module_info = res.data.module
                    this.$router.push({name:'sme.module.view', params:{id: this.module_info.id}})
                      
                    }).catch((error) => {
                        console.log(error);
                    });	

        }
    }
}
</script>
<style scoped>
.input-content .input-course-title {
    font-size: 1.6em;
}
.input-content .input-lesson-title {
    font-size: 1.2em;
}
.deneme{
    background-color:#f5f5f5;
    min-height: 100px !important;
}
.hadi{
    background-color:#f5f5f5;
    border: 5px solid white;
    border-radius: 8px;
}
.general-border{
    border: 5px solid white;
    border-radius: 8px;
}
.white-background{
    background-color:#fff !important;
}
.put_content_right{
    margin-left:auto;
}

</style>



// WEBPACK FOOTER //
// src/components/sme/modules/SMEModuleCreate.vue